import React from "react";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useCurrentOrganisationId } from "../../../../../services/local/organisationContext/OrganisationContextModel";
import { ImpactVisualisationsPlaceholderPageModel } from "./ImpactvisualisationsPlaceholderPage_model";

export interface ImpactVisualisationsPlaceholderPageProps {
  model: ImpactVisualisationsPlaceholderPageModel;
}

const ImpactVisualisationsPlaceholderPage: React.FunctionComponent<ImpactVisualisationsPlaceholderPageProps> = observer(
  props => {
    let { model } = props;
    const organisationId = useCurrentOrganisationId();
    const { projectId } = useParams<{ projectId: string }>();

    useEffect(() => {
      model.onMount();
      return model.onUnmount;
    }, [projectId, organisationId, model]);

    return <p>{model.title || "Placeholder title"}</p>;
  }
);

export { ImpactVisualisationsPlaceholderPage };
